import AbstractDbSelect from './abstract-db-select';

class DbSelect extends AbstractDbSelect {
    protected selectContainerClass = 'form-group';
    protected validOptionsSelector = 'option[value!=""]';
}
export default function () {
    $(function () {
        new DbSelect().init();
    });
}

